import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateFn } from '@angular/router';
import { SeguridadService } from '../service/seguridad/seguridad.service';
import { EnvconfigService } from '../service/envconfig.service';
import { EncryptDecryptService } from '../service/seguridad/EncryptDecryptService.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
class InternalAppGuardService {

  constructor(
    private seguridadService: SeguridadService,
    private router: Router,
    private environment: EnvconfigService,
    private encrypService: EncryptDecryptService,
    private helper: JwtHelperService
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    let TokeStorage = localStorage.getItem("access_token")!;
    const paramsAreNull = route.queryParams["u"] == undefined && route.queryParams["i"] == undefined && route.queryParams["s"] == undefined;
    if (paramsAreNull && TokeStorage == null && TokeStorage == undefined) {
      window.location.href = this.environment.get("loginurl");
    }
    if (paramsAreNull && TokeStorage != undefined && TokeStorage != null) {
      const SubMenuURL = state.url;
      //await this.seguridadService.decodeToken();
      if (SubMenuURL.includes("/home/inicio")) {
        return true;
      }

      const isValidMenu = this.seguridadService.ValidarOpcionMenu(SubMenuURL);

      // if (SubMenuURL.includes("/bpagador/registrosolicitud")) return true;

      // if (SubMenuURL.includes("/honramiento/registro")) return true;
      // if (SubMenuURL.includes("/honramiento/simulador")) return true;

      // if (SubMenuURL.includes("/bpagador/registrosolicitud")) return true;

      // if (SubMenuURL.includes("/honramiento/registro")) return true;
      // if (SubMenuURL.includes("/honramiento/simulador")) return true;

      if (!isValidMenu) {
        // Si la validación de la opción de menú es falsa, redirigir a 'pagina-403'
        this.router.navigate(['pagina-403']);
        return false; // Asegúrate de devolver false para indicar que la navegación ha sido cancelada
      }

      // Si la validación es exitosa, permitir la navegación
      return true;
    }

    const _codusuario = this.encrypService.decryptUsingAES256(route.queryParams["u"].replace(/\s+/g, '')) ?? "";
    const _idsistema = this.encrypService.decryptUsingAES256(route.queryParams["i"]) ?? "";
    const _sistema = this.encrypService.decryptUsingAES256(route.queryParams["s"]) ?? "";
    const _token = route.queryParams["t"].trim() ?? "";
    //const _token  = route.queryParams["t"].split('').reverse().join('')??"";
    if ((_token === undefined || _token === "") && (_codusuario === undefined || _codusuario === "")
      && (_sistema === undefined || _sistema === "")) {

      const SubMenuURL = state.url;

      if (localStorage.length === 0) {
        this.router.navigate(['pagina-403']);
        return false;
      }

      if (SubMenuURL.includes('/home/inicio') || SubMenuURL.includes('/cobertura/extorno/resultado')) {
        return true;
      }

      let data = localStorage.getItem(this.environment.get("LISTA_SUBMENU"));
      if (data == null || data === undefined) {
        this.router.navigate(['pagina-403']);
        return false;
      }
      let objetos = JSON.parse(data);
      if (!Array.isArray(objetos)) {
        objetos = [objetos];
      }
      let TieneAcceso: boolean = false;
      objetos.forEach(submenu => {
        if (submenu.url) {
          if (submenu.url.includes(SubMenuURL.slice(1))) {
            TieneAcceso = true;
          }
        }
      });

      if (!TieneAcceso) {
        this.router.navigate(['pagina-403']);
        return false;
      }
    }
    else {
      if (this.helper.isTokenExpired(_token)) {
        console.error("Token expirado");
        this.router.navigate(['pagina-401']);
      } else {
        localStorage.setItem(this.environment.get("TOKEN_NAME"), _token);
        //localStorage.setItem(this.environment.get("USERCODE"), _codusuario);
        localStorage.setItem(this.environment.get("SISTEMA"), _sistema);
        localStorage.setItem(this.environment.get("IDSISTEMA"), _idsistema);
        //await this.seguridadService.decodeToken();
        const response: any = await this.seguridadService.IngresarProducto();
        await this.seguridadService.obtenerIPPublica();
        // this.seguridadService.setLocalIP();
        if (response == null || response.data == null || response.data.nombreUsuario == null ||
          response.data.lstMenu == null) {
          this.router.navigate(['pagina-401']);
        }
        const _nuevoToken = response.data.jwtToken.token.trim() ?? "";
        const _codigoEntidad = response.data.lstEntidad[0].codigoEntidad;
        const _nombreEntidad = response.data.lstEntidad[0].nombreEntidad;
        const _idEntidad = response.data.lstEntidad[0].idEntidad;
        const _rol = response.data.codigoRolUsuario.trim();
        const _rolNombreUsuario = response.data.nombreRolUsuario.trim();
        const _nombreUsuario = response.data.nombreUsuario;
        localStorage.setItem(this.environment.get("TOKEN_NAME"), _nuevoToken);
        localStorage.setItem(this.environment.get("IFICODE"), _codigoEntidad);
        //localStorage.setItem(this.environment.get("IDIFI"), _idEntidad);
        localStorage.setItem(this.environment.get("IFI"), _nombreEntidad);
        //localStorage.setItem(this.environment.get("ROL"), _rol);
        localStorage.setItem(this.environment.get("NOMBRE_ROL_USUARIO"), _rolNombreUsuario)
        localStorage.setItem(this.environment.get("USERNAME"), _nombreUsuario);
        const _listaMenu = response.data.lstMenu;
        const _listaSubMenu = response.data.lstSubMenu;
        localStorage.setItem(this.environment.get("LISTA_MENU"), JSON.stringify(_listaMenu));
        localStorage.setItem(this.environment.get("LISTA_SUBMENU"), JSON.stringify(_listaSubMenu));
        setTimeout(() => {
          this.router.navigate(['/home/inicio']);
        }, 50);
      }
    }
    return true;
  }
}

export const AppGuardService: CanActivateFn = async (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  return await inject(InternalAppGuardService).canActivate(next, state);
}